module.exports = __webpack_public_path__ + "img/back-home-btn.1a0231b4.png";